import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { PaymentReasonForm, PaymentReasonResult, UpdatePaymentReasonModal } from 'components/PaymentReasonList';
import { DateForm, LoadingBar } from 'components/Commons';
import { Button, Form, Grid } from 'semantic-ui-react';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

import * as commonAction from 'actions/commons';
import * as usgAction from 'actions/usage';
import { getPaymentReasonList, setPaymentReasonFilter, updatePaymentReasons } from 'actions/paymentReason';

moment.tz.setDefault('Asia/Seoul');

class PaymentReasonList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  async componentWillMount() {
    cm.propsInit(this.props);
    const { cmAPI } = this.props;
    await cmAPI.divisionSel();
    await this.getPaymentReasonList();
  }

  componentDidMount() {
    cm.mainTitle('식대 결제사유 내역');
  }

  // 조회
  submitForm = async (e) => {
    // e.preventDefault();
    await this.getPaymentReasonList();
  };

  getDivision = async () => {
    try {
      const { cmAPI } = this.props;
      await cmAPI.divisionList();
    } catch (e) {
      const { code, message } = e || {};
      if (code) {
        toastr('top-right', 'error', message);
      } else {
        console.error('###### divisionSearch : ', e);
      }
    }
  };

  getPaymentReasonList = async (pageNum) => {
    const { paymentReasonAction, cmAPI, filter, date, depth } = this.props;
    const { sDate = moment().startOf('month'), eDate = moment() } = date || {};
    const { type: paymentReasonType, reason: paymentReasonText, name, store: storeName, page, pageRow } = filter;
    const params = {
      startdate: moment(sDate).format('YYYY-MM-DD'),
      enddate: moment(eDate).format('YYYY-MM-DD'),
      orgCode: depth ? depth.value : null,
      name,
      storeName,
      paymentReasonType,
      paymentReasonText,
      page: pageNum || page,
      pagerow: pageRow
    };
    try {
      await paymentReasonAction.getPaymentReasonList(params);
    } catch (error) {
      const { code, message } = error || {};
      if (code) {
        toastr('top-right', 'warning', message);
      }
    }

    cmAPI.changeExcel({
      excel: params
    });
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  // 페이지 이동
  handlePage = async (pageNum) => {
    const { paymentReasonAction } = this.props;
    paymentReasonAction.onFilterChange({ page: pageNum });
    await this.getPaymentReasonList(pageNum);
  };

  // 수정 모달 열기
  openModal = async () => {
    const { reasons } = this.props;
    const countChecked = reasons.filter(({ isChecked }) => isChecked);
    if (!countChecked.length) {
      alert('수정하실 결제 내역을 먼저 선택해주세요.');
      return;
    }
    await this.setState({
      modal: true
    });
  };

  // 수정 모달 닫기
  closeModal = async (type, value) => {
    this.setState({ modal: false });
    if (type === 'ok') {
      const { reasons } = this.props;
      const couponGroups = reasons
        .filter((e) => e.isChecked)
        .map(({ payment: { reasonId, cid, uid }, user: { comId } }) => ({ reasonId, cid, uid, comId }));
      if (couponGroups.length) {
        const data = {
          paymentReason: value,
          couponGroups
        };
        await this.updatePaymentReason(data);
        await this.getPaymentReasonList(1);
      }
    }
  };

  updatePaymentReason = async (reason) => {
    try {
      const { paymentReasonAction } = this.props;
      const targetIds = await paymentReasonAction.updatePaymentReasons(reason);
    } catch (error) {
      const { code, message } = error || {};
      if (code) {
        toastr('top-right', 'warning', message);
      }
    }
  };

  render() {
    const { modal } = this.state;
    const { pending } = this.props;
    let loading = '';

    if (pending) {
      loading = <LoadingBar />;
    }

    return (
      <main className="maf">
        {loading}
        <PaymentReasonForm onSubmit={this.submitForm} />
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14} />
            <Grid.Column width={2} className="form-right btn-update-reason-container">
              <Button color="black" inverted content="수정" onClick={this.openModal} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <PaymentReasonResult handlePage={this.handlePage} modal={modal} />
        <UpdatePaymentReasonModal open={modal} close={this.closeModal} />
      </main>
    );
  }
}

export default connect(
  (state) => ({
    date: state.commons.date,
    depth: state.commons.depth,
    groupIdx: state.commons.group,
    division: state.commons.division,
    filter: state.paymentReason.searchFilter,
    reasons: state.paymentReason.paymentReasonList,
    pending: state.paymentReason.pending
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        divisionSel: commonAction.PastDivisionList,
        changeExcel: commonAction.ChangeExcel
      },
      dispatch
    ),
    paymentReasonAction: bindActionCreators(
      {
        onFilterChange: setPaymentReasonFilter,
        getPaymentReasonList,
        updatePaymentReasons
      },
      dispatch
    ),
    usageAPI: bindActionCreators(
      {
        sikDetailList: usgAction.SikdaeDtlList,
        sikListDetail: usgAction.SikdaeListDtl,
        excelDownload: usgAction.ExcelSikdaeDtlList
      },
      dispatch
    )
  })
)(PaymentReasonList);
